<template>
  <span>{{ getSymbol() }}</span>
</template>
<script>
import ls from "store2";
export default {
  props: ["code"],
  data() {
    return {
      symbol: "",
    };
  },

  created() {},
  methods: {
    getSymbol() {
      const self = this;
      const currentCurrencies = ls.session("CURRENCIES");
      if (currentCurrencies == null) {
        return self.code;
      }
      if (self.code === "" || self.code == null) {
        return;
      }
      const currencyObj = currentCurrencies.find((r) => r.code === self.code);
      if (currencyObj != null) {
        return currencyObj.symbol;
      } else {
        return self.code;
      }
    },
  },
};
</script>